import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'nallian-shared-ui/lib/components';
import { createShortAppName } from 'nallian-shared-ui/lib/lib/createShortAppName';
import {
  AppLink,
  ImageCard,
  NonImageCard,
  APP_TAG_IMAGE_MAP,
} from 'nallian-shared-ui/lib/layout/UserApps';

export const getAppUrl = app => {
  if (!app.url) return null;
  return `${/^([a-z]+:){0,1}\/\//.test(app.url) ? '' : '//'}${app.url.replace(
    '[EnvironmentUrl]',
    `${window.location.host}/`
  )}`;
};

const AppIconContent = ({ app }) => (
  <>
    {APP_TAG_IMAGE_MAP[app.appTag] ? (
      <ImageCard raised image={APP_TAG_IMAGE_MAP[app.appTag]} />
    ) : (
      <NonImageCard className="ui card" big>
        {app.shortName || createShortAppName(app.name)}
      </NonImageCard>
    )}
    <AppLink className="link">{app.name}</AppLink>
  </>
);

AppIconContent.propTypes = {
  app: PropTypes.object.isRequired,
};

const AppIcon = ({ app }) => {
  if (app.internalRoute) {
    return (
      <Link to={app.internalRoute} className="link">
        <AppIconContent app={app} />
      </Link>
    );
  }

  if (app.url) {
    return (
      <ExternalLink className="link" href={getAppUrl(app)}>
        <AppIconContent app={app} />
      </ExternalLink>
    );
  }

  return <AppIconContent app={app} />;
};

AppIcon.propTypes = {
  app: PropTypes.object.isRequired,
};

export default AppIcon;
